const styles = {
    logoNav: {
        width: '100vw',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '15px',
    },
    img: {
        width: '200px',
        marginLeft: '10px'
    }
};

export default styles;